import { getAnnouncementImageUrl } from './imageUrl';
import { isDeliveryPaymentMessage } from './colissimoPaymentMessage';
import { getConversationsForFoundObject } from './foundObjectConversation';

/** @see sherlook-frontend-next/src/utils/colissimoLabel.ts */
export function extractEtiquetteUrlFromContent(content: string): string | null {
  const match = content.match(/Etiquette:\s*(\S+)/i);
  if (!match?.[1]) return null;
  const raw = match[1].replace(/[)\].,;!?]+$/g, '').replace(/\.$/, '');
  if (!raw) return null;
  return getAnnouncementImageUrl(raw);
}

export function extractTrackingNumberFromContent(content: string): string | null {
  const match = content.match(/Tracking:\s*([A-Za-z0-9]+)/i);
  return match?.[1] ?? null;
}

type ConversationForLabel = {
  id?: number;
  last_message?: { content?: string | null } | null;
  announcement?: {
    object_attributes?: Record<string, unknown> | null;
    reference_code?: string | null;
  } | null;
};

/**
 * Retrouve l’URL du bon d’expédition pour un objet trouvé
 * (dernier message, sinon messages de la conversation liée).
 */
export async function resolveFoundObjectEtiquetteUrl(
  foundObjectId: number,
  conversations: ConversationForLabel[],
  fetchConversation: (id: number) => Promise<{ messages?: Array<{ content?: string | null }> }>
): Promise<string | null> {
  const linked = getConversationsForFoundObject(conversations, foundObjectId);
  for (const conversation of linked) {
    const fromLast = extractEtiquetteUrlFromContent(String(conversation.last_message?.content ?? ''));
    if (fromLast) return fromLast;
  }
  for (const conversation of linked) {
    const conversationId = Number(conversation.id);
    if (!Number.isFinite(conversationId) || conversationId <= 0) continue;
    const detail = await fetchConversation(conversationId);
    for (const message of detail.messages ?? []) {
      const content = String(message.content ?? '');
      if (!isDeliveryPaymentMessage(content)) continue;
      const url = extractEtiquetteUrlFromContent(content);
      if (url) return url;
    }
  }
  return null;
}
